import Image from "next/image";
import React from "react";

const AppDownload = ({ textColor, lg }) => {
  return (
    <section
      className={`app-download-section bg-gradient-to-r ${lg} w-full bg-white relative mb-[80px] sm:mb-[185px] md:mt-[120px] md:mb-[30px] lg:mb-[30px] h-[500px] md:h-[430px] lg:h-[450px]`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16">
        {/* Main Container */}
        <div className="flex flex-col md:flex-row items-center gap-8 sm:gap-12 lg:gap-16">
          {/* Left Side - Text & Download Buttons */}
          <div className="w-full md:w-1/2 flex flex-col items-start md:items-start text-center lg:text-left md:text-left gap-4 sm:gap-6 lg:gap-4 z-10">
            <h3 className={`text-[32px] md:text-[44px] leading-[1.1] font-semibold ${textColor} w-full   lg:max-w-[500px]`}>
              Gold at Your Fingertips!
            </h3>
            <p className={`text-base md:text-lg  ${textColor} w-full lg:max-w-[500px]`}>
              Buy, sell, and save real gold any time, any where. {" "}
              <br className="block" />
              Download Now
            </p>

            {/* Download Buttons */}
            <div className="flex justify-center md:justify-normal w-full flex-row gap-4 sm:gap-6 md:mt-6">
              <a
                href="https://play.google.com/store/apps/details?id=com.justgold"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => window.trackAppDownload('android')}
                className="transform hover:scale-105 transition-transform duration-300"
              >
                <Image
                  src="/googleplay.svg"
                  alt="Google Play Store"
                  width={160}
                  height={50}
                  className="w-36 sm:w-40 h-auto"
                />
              </a>
              <a
                href="https://apps.apple.com/in/app/just-gold/id6744900430"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => window.trackAppDownload('ios')}
                className="transform hover:scale-105 transition-transform duration-300"
              >
                <Image
                  src="/app-store.svg"
                  alt="Apple App Store"
                  width={160}
                  height={50}
                  className="w-36 sm:w-40 h-auto"
                />
              </a>
            </div>
          </div>

          {/* Right Side - Dual Phone Image with 3D Effect */}
          <div className="w-full md:w-1/2 relative">
            <div className="relative w-full max-w-[300px] sm:max-w-[400px] lg:max-w-[500px] mx-auto md:mx-0 md:absolute md:top-[-200px] lg:top-[-252px] right-0">
              <Image
                src="/dual-phone.png"
                alt="Just Gold App on Phones"
                width={500}
                height={500}
                className="w-full h-auto object-contain 
                         drop-shadow-[0_20px_50px_rgba(0,0,0,0.25)]"
                priority
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppDownload;
